import { render, staticRenderFns } from "./current-with-dashboardbutton.vue?vue&type=template&id=c60f5708&scoped=true&"
import script from "./current-with-dashboardbutton.vue?vue&type=script&lang=ts&"
export * from "./current-with-dashboardbutton.vue?vue&type=script&lang=ts&"
import style0 from "./current-with-dashboardbutton.vue?vue&type=style&index=0&id=c60f5708&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c60f5708",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCol,VRow})
